import { createSlice } from '@reduxjs/toolkit'

import { reducerRegistry } from 'reducer-registry'

import { SUL_ANALYTICS_TYPES } from './constants'

const initialState = {
  formInitialValues: {},
  [SUL_ANALYTICS_TYPES.SFC_CUSTOMIZED_DETAILS]: [],
}

const slice = createSlice({
  name: 'singleUseLinkAnalytics',
  initialState,
  reducers: {
    cleanupSULAnalytics: (state, { payload = [] }) => {
      payload.forEach((analyticsType) => {
        state[analyticsType] = initialState[analyticsType]
      })
    },
    resetSULAnalytics: () => initialState,
    setSULAnalytics: (state, { payload }) => payload,
    setSULAnalyticsFormInitialValues: (state, { payload = {} }) => {
      state.formInitialValues = {
        ...state.formInitialValues,
        ...payload,
      }
    },
  },
})

reducerRegistry.add('singleUseLinkAnalytics', slice.reducer)

export const {
  cleanupSULAnalytics,
  resetSULAnalytics,
  setSULAnalytics,
  setSULAnalyticsFormInitialValues
} = slice.actions
